import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import { BOW_TARGET } from '../../../../../Widgets/DataPainterWidget/BatteryOverviewWidget/batteryOverviewConst';
import commandEngine from './CommandEngine';
import { CMD_BATTERY_OVERVIEW_REGISTRY_KEY, META_TYPE, META_VER } from './batteryOverviewCommandRegisteryType';

/**
 * Registers the /bats command with the CommandEngine.
 * /bats — opens/refocuses the battery overview (single instance, target=all).
 */
export function registerBatteryOverviewCommand() {
    commandEngine.register('/bats', {
        hint: 'open battery overview (all batteries, level, power, left)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_BATTERY_OVERVIEW_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: BOW_TARGET });
        },
    });
}
